/** Large, grouped approval code that a person can read out to IT. */
export function DeviceCode({ code, className }: { code: string | null; className?: string }) {
  if (!code) return null
  const [first, second] = code.split('-')
  return (
    <p className={className ? `device-code ${className}` : 'device-code'} data-testid="device-code">
      <span className="sr-only">Approval code: </span>
      <span className="device-code-group">{first}</span>
      {second ? (
        <>
          <span className="device-code-sep" aria-hidden="true">
            -
          </span>
          <span className="device-code-group">{second}</span>
        </>
      ) : null}
    </p>
  )
}
